import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { NotificationService, PagedSearch } from 'src/app/shared';
import { ControlContainer, NgForm } from '@angular/forms';
import { PledgeService } from 'src/app/revenue/shared/pledge/pledge.service';
import { RevenueItemService } from 'src/app/revenue/shared/revenue-items/revenue-item.service';
import { PledgeLevelService } from 'src/app/revenue/shared/pledge/pledge-level.service';
import { BillingService } from 'src/app/revenue/shared/billing/billing.service';
import { PledgeLevelSearchDto } from 'src/app/revenue/shared/pledge/dto/pledge-level-search.dto';
import { PledgeLevelDto } from 'src/app/revenue/shared/pledge/dto/pledge-level.dto';
import { PledgeDto } from 'src/app/revenue/shared/pledge/dto/pledge.dto';
import { RevenueItem } from 'src/app/revenue/shared/revenue-items/revenue-item.model';
import { BillingCycle } from 'src/app/revenue/shared/billing/billing-cycle.model';
import { UserService } from 'src/app/users/shared/user.service';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-pledge-edit-details',
  templateUrl: './pledge-edit-details.component.html',
  styleUrls: ['./pledge-edit-details.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class PledgeEditDetailsComponent implements OnInit {
  @Input() pledge: PledgeDto;
  pledgeLevels: SelectItem[] = [];
  revItems: SelectItem[] = [];
  billCycles: SelectItem[] = [];
  activeUsers: SelectItem[] = [];

  pledgeLevelSearch = new PagedSearch() as PledgeLevelSearchDto;

  constructor(
    private _notificationService: NotificationService,
    private _revenueItemService: RevenueItemService,
    private _pledgeLevelService: PledgeLevelService,
    private _billingService: BillingService,
    private _userService: UserService
  ) {}

  ngOnInit() {
    this.getPledgeLevels();
    this.getBillingCycles();
    this.getRevenueItems();
    this.getActiveUsers();
  }

  private getPledgeLevels() {
    this._pledgeLevelService
      .searchPledgeLevels(this.pledgeLevelSearch)
      .then((data) => {
        if (data.TotalCount > 0) {
          this.pledgeLevels = data.Result.map<SelectItem>((x: PledgeLevelDto) => {
            return { label: x.PledgeLevel1, value: x.PledgeLevel1 };
          });
        }
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  private getRevenueItems() {
    this._revenueItemService
      .getAllRevenueItems()
      .then((data) => {
        if (data.length > 0) {
          this.revItems = data.map<SelectItem>((x: RevenueItem) => {
            return { label: x.ItemName, value: x.ItemNum };
          });
        }
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  private getBillingCycles() {
    this._billingService
      .getBillingCycles()
      .then((data) => {
        if (data.length > 0) {
          this.billCycles = data.map<SelectItem>((x: BillingCycle) => {
            return { label: x.Name, value: x.Name };
          });
        }
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  private getActiveUsers() {
    this._userService.getActiveUsers().then((data) => {
      if (data.length > 0) {
        this.activeUsers = data.map<SelectItem>((x) => {
          return { label: x.UserName, value: x.UserNum };
        });
        this.activeUsers.sort((a, b) => a.label.localeCompare(b.label));
      }
    });
  }
}
